import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../Fct/generics';
import { NONFUNGIBLE_POSITION_MANAGER_ADDRESSES } from '../helpers/constants';
export var IncreaseLiquidity = createPlugin({
    protocol: 'UNISWAP_V3',
    type: 'ACTION',
    method: 'increaseLiquidity',
    supportedContracts: NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                params_tuple: {
                    tokenId: new FctValue({ destination: 'eip712_tokenId' }),
                    amount0Desired: new FctValue({ destination: 'wei_amount' }),
                    amount1Desired: new FctValue({ destination: 'wei_amount' }),
                    amount0Min: new FctValue({ destination: 'wei_amount' }),
                    amount1Min: new FctValue({ destination: 'wei_amount' }),
                    deadline: new FctTimestamp({}),
                },
            },
        },
        output: {
            liquidity: new FctValue({ innerIndex: 0 }),
            amount0: new FctValue({ innerIndex: 1 }),
            amount1: new FctValue({ innerIndex: 2 }),
        },
    }); },
    initParams: {
        methodParams: {
            params_tuple: {
                deadline: { type: 'global', id: 'blockTimestamp' },
                amount0Min: '0',
                amount1Min: '0',
            },
        },
    },
});
